class GlobalDialogControl {
  constructor() {
    this.list = [];
    this.current = null;
    this.opened = [];
  }

  /**
   *
   * @param {{key?: string, dialog: {open: (any)=>void}, props?: any, priority?: number, okNext?: boolean}} param
   * @returns
   */
  push({ key, dialog, props, priority = 100, okNext }) {
    if (key) {
      // 避免重复弹框
      const match = this.list.find((d) => d.key === key);
      if (match) return;
    }

    this.list.push({
      key,
      dialog,
      props,
      // 优先级
      priority,
      okNext,
    });

    // 根据优先级排序， 数字越小，优先级越高
    this.list.sort((prev, cur) => {
      return prev.priority - cur.priority;
    });

    // 异步打开，需要等一批弹框进入后，优先级排序完成后再进行展示
    setTimeout(() => {
      if (this.current === null) {
        // 优先级
        this.openDialog();
      }
    }, 0);
  }

  async openDialog() {
    const { dialog, props = {}, okNext } = this.list.shift() || {};
    if (dialog) {
      let _props = props;
      this.current = dialog;

      if (typeof props === "function") {
        _props = await props();

        if (!_props) {
          this.openDialog();
          return;
        }
      }

      this.current = dialog.open({
        ..._props,
        onOk: () => {
          _props.onOk && _props.onOk();

          if (okNext) {
            this.openDialog();
          } else {
            // 点击确认按钮后清空下弹框列表，避免后续动作有弹框
            this.current = null;
            this.list = [];
          }
        },
        onCancel: () => {
          _props.onCancel && _props.onCancel();
          // 关闭当前则打开下一个弹框，打开下一个弹框
          this.openDialog();
        },
      });
    } else {
      // 当没有弹框了就需要重置
      this.current = null;
      this.list = [];
    }
  }
}

export const globalDialogControl = new GlobalDialogControl();
